/**
 @ngdoc service
 @name mapTimesheetTileService
 @description
 factory used by mapTilesJsonData.js to construct tile data into tileData object
 */

(function() {
    'use strict';

    var mapTimesheetTileService = function(tileDataFactory) {

        var map = function(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData){
            var self = this;

            // Assigning tile factory function with parameters to variable
            var tileFactory = new tileDataFactory.constructTileData(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData);

            // Adding labels to column structured data
            if(rawTileData.itemCorporateURI){
                tileFactory.addFieldToColumn1(tileFactory.field.newLinkBusinessModelField('jobId', 'itemPrincipleURI', 'itemCorporateURI'));
            }
            else {
                tileFactory.addFieldToColumn1(tileFactory.field.newLinkField('jobId','itemPrincipleURI'));
            }
            if(rawTileData.isManagerOrCandidate==false) {
                tileFactory.addFieldToColumn1(tileFactory.field.newLinkField('candidateName', 'candidateURI'));
            }
            else if(rawTileData.isManagerOrCandidate==true) {
                tileFactory.addFieldToColumn1(tileFactory.field.newField('candidateName'));
            }

            tileFactory.addFieldToColumn1(tileFactory.field.newField('taxStatus'));

            if(!tileFactory.isPrincipal()){
                tileFactory.addFieldToColumn1(tileFactory.field.newField('job'));
            }

            if(tileFactory.isPrincipal()){
                tileFactory.addFieldToColumn2(tileFactory.field.newLinkField('procurerOrgUnitName','businessURI'));
                tileFactory.addFieldToColumn2(tileFactory.field.newLinkField('authorisingManagerName', 'authorisingManagerURI'));
            }

            if(rawTileData.authorisedOn) {
                tileFactory.addFieldToColumn2(tileFactory.field.newField('authorisedOn', 'dateTime'));
            }

            if(!tileFactory.isPrincipal()){
                tileFactory.addFieldToColumn2(tileFactory.field.newAddressField('bookingWorkingAddress'));
                tileFactory.addFieldToColumn2(tileFactory.field.newOrganisationField('procurerOrgUnitName', 'procurerOrgName'));
                tileFactory.addFieldToColumn2(tileFactory.field.newOrganisationField('supplierOrgUnitName','supplierOrgName'))
            }

            if(tileFactory.isPrincipal()){
                tileFactory.addFieldToColumn3(tileFactory.field.newField('weekEndDate', 'dateTime'));
            }

            if(!tileFactory.isPrincipal() && rawTileData.startDate){
                tileFactory.addFieldToColumn3(tileFactory.field.newDateRangeField('startDate', 'endDate'));
            }

            if (!rawTileData.suppressTimeClaimed) {
                if (rawTileData.totalDays) {
                    tileFactory.addFieldToColumn3(tileFactory.field.newTimeField('totalDays'));
                } else {
                    tileFactory.addFieldToColumn3(tileFactory.field.newTimeField('totalHours'));
                }
            }
            tileFactory.addFieldToColumn3(tileFactory.field.newField('submittedOn', 'dateTime'));

            if(tileFactory.isPrincipal()){
                tileFactory.addFieldToColumn4(tileFactory.field.newField('leadConsultant'));
            }

            if(!tileFactory.isPrincipal()){
                tileFactory.addFieldToColumn4(tileFactory.field.newFieldBooleanYesOrNo('alteredByUser'));
                tileFactory.addFieldToColumn4(tileFactory.field.newField('comments'));
                tileFactory.addFieldToColumn4(tileFactory.field.newField('alterationComments'));
            }
            if(rawTileData.activity1!=null) {
                tileFactory.addFieldToColumn4(tileFactory.field.newFieldWIthDefinedLabel('activity1', 'activity1Name'));
            }
            if(rawTileData.activity2!=null) {
                tileFactory.addFieldToColumn4(tileFactory.field.newFieldWIthDefinedLabel('activity2', 'activity2Name'));
            }
            if(rawTileData.activity3!=null) {
                tileFactory.addFieldToColumn4(tileFactory.field.newFieldWIthDefinedLabel('activity3', 'activity3Name'));
            }
            tileFactory.addFieldToColumn4(tileFactory.field.newFieldBooleanYesOrNo('activeOvertime'));

            // 533: "Awaiting Authorisation"
            // 534: "Awaiting Resubmission"
            // 535: "Awaiting Repost (financials)"
            // 536: "Rejected"
            // 537: "Authorised"
            // 4826: "Cancelled"
            // 4827: "Awaiting Repost (allocation)"
            // 4953: "In Review"
            // 4954: "Processing"
            // 5161: "Awaiting Overtime Authorisation"
            // 5276: "Reversed"
            // 5397: "Awaiting Repost Authorisation (allocation)"
            // 5398: "Awaiting Repost Authorisation (financials)"

            if(rawTileData.additionalTimesheetStatus){
                tileFactory.addStatus(tileFactory.status.newCombinedStatus('timesheetStatus','additionalTimesheetStatus',
                    [
                        [
                            tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_AUTHORISED,
                            rawTileData.additionalTimesheetStatus
                        ]
                    ],
                    [
                        [
                            tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_CANCELLED,
                            rawTileData.additionalTimesheetStatus
                        ],
                        [
                            tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_REJECTED,
                            rawTileData.additionalTimesheetStatus
                        ]
                    ],
                    [
                        [
                            tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_AWAITING_AUTHORISATION,
                            rawTileData.additionalTimesheetStatus
                        ],
                        [
                            tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_AWAITING_REPOST_FINANCIALS,
                            rawTileData.additionalTimesheetStatus
                        ],
                        [
                            tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_AWAITING_RESUBMISSION,
                            rawTileData.additionalTimesheetStatus
                        ],
                        [
                            tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_AWAITING_REPOST_ALLOCATION,
                            rawTileData.additionalTimesheetStatus
                        ],
                        [
                            tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_AWAITING_REPOST_AUTHORISATION_FINANCIALS,
                            rawTileData.additionalTimesheetStatus
                        ],
                        [
                            tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_AWAITING_OVERTIME_AUTHORISATION,
                            rawTileData.additionalTimesheetStatus
                        ],
                        [
                            tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_IN_REVIEW,
                            rawTileData.additionalTimesheetStatus
                        ],
                        [
                            tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_AWAITING_REPOST_AUTHORISATION_ALLOCATION,
                            rawTileData.additionalTimesheetStatus
                        ]
                    ]
                ));
            }else{
                tileFactory.addStatus(tileFactory.status.newStatus('timesheetStatus',
                    [
                        tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_AUTHORISED
                    ],
                    [
                        tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_CANCELLED,
                        tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_REJECTED
                    ],
                    [
                        tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_AWAITING_AUTHORISATION,
                        tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_AWAITING_REPOST_FINANCIALS,
                        tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_AWAITING_RESUBMISSION,
                        tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_AWAITING_REPOST_ALLOCATION,
                        tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_AWAITING_REPOST_AUTHORISATION_FINANCIALS,
                        tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_AWAITING_OVERTIME_AUTHORISATION,
                        tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_IN_REVIEW,
                        tileFactory.LOOKUP_VALUE.PERM_START_CONFIRMATION_AWAITING_REPOST_AUTHORISATION_ALLOCATION
                    ]
                ));
            }

            if(rawTileData.statusname !="Not Submitted" && !rawTileData.suppressTimeClaimed){
                tileFactory.tileData.timesheetSummary = {};
                if(rawTileData.timeRecordDaily.length > 0){
                    tileFactory.tileData.timesheetSummary.data = rawTileData.timeRecordDaily;
                    tileFactory.tileData.timesheetSummary.type = 'daily';
                }else{
                    tileFactory.tileData.timesheetSummary.data = rawTileData.timeRecordHourly;
                    tileFactory.tileData.timesheetSummary.type = 'hourly';
                }
                tileFactory.tileData.timesheetSummary.startDate = rawTileData.startDate;
                tileFactory.tileData.timesheetSummary.endDate = rawTileData.endDate;
            }

            return tileFactory.tileData;

        };

        return {
            map : map
        };
    };

    mapTimesheetTileService.$inject = ['tileDataFactory'];
    angular.module('app').factory('mapTimesheetTileService', mapTimesheetTileService);

}());